/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Planninghorizondays2Inputs */

const en_planninghorizondays2 = /** @type {(inputs: Planninghorizondays2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} days ahead`)
};

const de_planninghorizondays2 = /** @type {(inputs: Planninghorizondays2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Tage im Voraus`)
};

/**
* | output |
* | --- |
* | "{count} days ahead" |
*
* @param {Planninghorizondays2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const planninghorizondays2 = /** @type {((inputs: Planninghorizondays2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planninghorizondays2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_planninghorizondays2(inputs)
	return de_planninghorizondays2(inputs)
});
export { planninghorizondays2 as "planningHorizonDays" }